function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.9203 6.13148H20.0759C20.0357 6.11809 19.9643 6.06006 19.942 6.02435L19.2457 3.52492C19.0761 2.78401 18.6342 2.10113 18.0049 1.59678C17.38 1.09689 16.6213 0.820168 15.8759 0.820168H3.08413C1.38362 0.820168 0 2.23057 0 3.96232V31.8623C0 33.5941 1.38362 35 3.08413 35H36.9203C37.7326 35 38.5003 34.6786 39.0805 34.0984C39.6741 33.5003 40.0044 32.7059 40 31.8578V9.27363C40.0044 7.54187 38.6208 6.13148 36.9203 6.13148ZM2.99074 3.96166C2.99074 3.87686 3.04429 3.80991 3.08446 3.80991H15.8762C15.9298 3.80991 16.0325 3.84561 16.1351 3.93041C16.2467 4.01968 16.3047 4.11787 16.3226 4.17143V4.1759L16.9742 6.48788H2.99074V3.96166ZM37.0004 31.8631C37.0004 31.9122 36.987 31.9479 36.9558 31.9836C36.9335 32.0059 36.9201 32.0059 36.9112 32.0059H3.07946C3.04375 32.0059 2.98573 31.9434 2.98573 31.8542V9.64487H36.996V31.8631H37.0004Z",
  fill: "currentColor"
});

var SvgIcFolderDefault = function SvgIcFolderDefault(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 35,
    viewBox: "0 0 40 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcFolderDefault, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_folder_default.a4d3aaa0.svg";
export { ForwardRef as ReactComponent };